export default __webpack_public_path__ + "media/icons/Computer@2x-4dc72948.svg";